import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';

import { SharedService } from '../../../shared/shared.service';
import { ListPrenotatiProveFinaliDTO } from './../../../model/newModel';
import { PrenotazioniEsamiService } from './prenotazioni-esami.service';

@Component({
  selector: 'app-prenotazioni-esami',
  templateUrl: './prenotazioni-esami.component.html',
  styleUrls: ['./prenotazioni-esami.component.css'],
})
export class PrenotazioniEsamiComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  listPrenotatiProveFinali: ListPrenotatiProveFinaliDTO;

  ngOnInit(): void {
    super.ngOnInit();
    this.getList();
  }

  getList() {
    this.spinner.show();
    this.prenotazioniEsamiService.search(this.student.id).subscribe(
      (result) => {
        this.spinner.hide();
        this.listPrenotatiProveFinali = result;
      },
      (error) => {
        this.spinner.hide();
        console.log('Errore search');
      }
    );
  }

  eliminaPrenotazione(id: number, dataMassimaCancellazione: Date) {
    const currentDate = new Date();
    const currentDataMassimaCancellazione = new Date(dataMassimaCancellazione);
    if (
      currentDataMassimaCancellazione.toISOString() >= currentDate.toISOString()
    ) {
      this.spinner.show();
      this.prenotazioniEsamiService.delete(id).subscribe(
        (result) => {
          if (result) {
            this.spinner.hide();
            this.sharedService.openOkModal();
            this.modalSubscribe = this.ngxSmartModalService
              .getModal('okModal')
              .onClose.subscribe((modal: NgxSmartModalComponent) => {
                window.location.reload();
              });
          } else {
            this.spinner.hide();
            this.sharedService.openKoModal();
          }
        },
        (error) => {
          this.spinner.hide();
          console.log('Errore delete');
        }
      );
    } else {
      const text =
        'Non è possibile più eliminare la prenotazione perchè hai superato la data massima di cancellazione';
      this.sharedService.openWarningModal(text);
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  constructor(
    private spinner: NgxSpinnerService,
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    private sharedService: SharedService,
    private prenotazioniEsamiService: PrenotazioniEsamiService
  ) {
    super();
  }
}
